import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { RotatingLines } from 'react-loader-spinner';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams, BrowserRouter as Router, Route, Link } from "react-router-dom";

function CustomerHistory() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
    const [customerBackup, setCustomerBackup] = useState([]);
    // const [box, setBox] = useState([]);
    const [networkName, setNetworkName] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending", });
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(20);
    const [searchQuery, setSearchQuery] = useState("");
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    const { acc_num } = useParams();
    console.log(acc_num);

    const user = getCookie('user');
    if (!user) { navigate('/'); }
    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        const sortedData = [...allCustomer].sort((a, b) => {
            if (a[key] < b[key]) { return direction === "ascending" ? -1 : 1; }
            if (a[key] > b[key]) {
                return direction === "ascending" ? 1 : -1;
            }
            return 0;
        });
        setRowsData(sortedData);
        setSortConfig({ key, direction });
    };
    
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = allCustomer.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(allCustomer.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
   const fetchUserData = async () => {
    try {
        const response = await axios.post(
            'https://node.cabletvpay.in/HistoryCustomerGetInfo',
            { user, acc_num }
        );

        if (response.status === 200) {

            console.log("History Response:", response.data);

            // 🌟 Use UNION history result
            setCustomerBackup(response.data.customerBackup);    // <-- NEW
            setAllCustomer(response.data.allCustomer);  
            // 🌟 Box model
            // setBox(response.data.box);
        }

    } catch (err) {
        setError(err.response?.data?.message || "Error fetching data");

    } finally {
        setLoading(false);
    }
};

    useEffect(() => { fetchUserData(); }, []);
     if (loading) {
        return (<div className="content-wrapper">  <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>  <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="3" />  </div>  </div>);
      }
    
      if (error) {
        return (<div className="content-wrapper"> <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>  <img src="../asset/img/errorPage.jpg" alt="Error" style={{ height: "20rem" }} />  </div>  </div>);
      }
    return (
        <div className="content-wrapper" >
            <div className="content-header pt-1 px-2">
                   <div className="mt-3">
      <div className="d-flex align-items-center justify-content-between">
        <div className="fs-4 valuesDec h5">
          CUSTOMER HISTORY : {allCustomer[0]?.name}
        </div>
        <button
          className="btn btn-danger"
          onClick={() => navigate("/allcustomer/all")}
        >
          ← Back
        </button>
      </div>
    </div>
                <hr />
                <div className="container p-0">
                    <div className="row">
                        <div className="col-lg-6 col-12 ">
                           <div className="d-flex justify-content-lg-center">
                           <div className="card history text-bold">
                                <div className="card-header filterBtn shadow-none bg-navy text-bold text-light text-truncate py-3"><span className='p-2 bg-orange text-center rounded'><i className='fas fa-user-tie h4 p-0 m-0 text-light' /></span>
                                    &nbsp; Customer Details
                                </div>
                                <div className="card-body p-0">
                                    <div className="row m-0">
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Customer Code :</span> {allCustomer[0].acc_num}</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>STB Code :</span> {allCustomer[0].serial_num}</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Name :</span> {allCustomer[0].name}</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Mobile :</span> {allCustomer[0].mobile}</p>
                                        </div>
                                        <div className="col-12 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Address :</span> {allCustomer[0].doorno +", "+ allCustomer[0].street +", "+ allCustomer[0].flat_name}</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Staff Code :</span> {allCustomer[0].area_code}</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Network Name :</span> {allCustomer[0].net_name}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           </div>
                        </div>
                        <div className="col-lg-6 col-12">
                        <div className="d-flex justify-content-lg-center">
                           <div className="card history text-bold">
                                <div className="card-header filterBtn shadow-none bg-navy text-bold text-light text-truncate py-3"><span className='p-2 bg-orange text-center rounded'><i className='fas fa-calendar-alt h4 p-0 m-0 text-light' /></span>
                                    &nbsp; Current Month Details
                                </div>
                                <div className="card-body p-0">
                                    <div className="row m-0">
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Plan Amount :</span> {allCustomer[0].pay_amt}</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Pending Amount :</span> {allCustomer[0].pend_amt}</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Paid Amount :</span> {allCustomer[0].paid_amt}</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Payment Status :</span> {allCustomer[0].status}</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Balance Amount :</span> {allCustomer[0].balance_amt}</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Extra Balance Amount :</span> {allCustomer[0].extra_balance_amt ? allCustomer[0].extra_balance_amt : 0 }</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Connection Status :</span> {allCustomer[0].con_status }</p>
                                        </div>
                                        <div className="col-6 d-flex justify-content-start px-md-3 my-1 py-0">
                                            <p className="text-orange"><span className='text-navy'>Box Model/Type :</span>{allCustomer[0].con_type}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="card elevation-5 mt-3" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        
                    </div>
                    <div className="card-body p-0">
                        <table id="myTable" className="table table-striped bg-white table-bordered table-responsive-lg" style={{ backgroundColor: "rgba(151, 151, 151, 0.185)" }}>
                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Month</th>
                                    <th>Paid Date</th>
                                    <th>Paid Time</th>
                                    <th>Plan Amount</th>
                                    <th>Pending Amount</th>
                                    <th>Payment Status</th>
                                    <th>Paid Amount</th>
                                    <th>Balance Amount</th>
                                    <th>Extra Balance Amount</th>
                                    <th>Discount Amount</th>
                                    <th>Connection Status</th>
                                    <th>STB Number</th>
                                    <th>Collection Staff</th>

                                </tr>
                            </thead>
                            <tbody>
                                {customerBackup.length > 0 ? (
                                    customerBackup.map((row, index) => (
                                        <tr key={index}>

                                             <td  className='tableText border-dark text-bold'>{row.month}/{row.year}</td>
                                             <td  className='tableText border-dark text-bold'>{row.paid_date}</td>
                                             <td  className='tableText border-dark text-bold'>{row.paid_time}</td>
                                             <td  className='tableText border-dark text-bold'>{row.pay_amt}</td>
                                             <td  className='tableText border-dark text-bold'>{row.pend_amt}</td>
                                             <td  className='tableText border-dark text-bold'>{row.status}</td>
                                             <td  className='tableText border-dark text-bold'>{row.paid_amt}</td>
                                             <td  className='tableText border-dark text-bold'>{row.balance_amt}</td>
                                             <td  className='tableText border-dark text-bold'>{row.extra_balance_amt}</td>
                                             <td  className='tableText border-dark text-bold'>{row.discount}</td>
                                             <td  className='tableText border-dark text-bold'>{row.con_status}</td>
                                             <td  className='tableText border-dark text-bold'>{row.serial_num}</td>
                                             <td  className='tableText border-dark text-bold'>{row.col_boy}</td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="30">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="card-footer filterBtn">
            <div className="d-flex justify-content-end">
              <div className="pagination btn-group border-light">
                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light active" : "btn-dark"} border-left`} > 1 </button>
                {currentPage > 3 && <span className="mx-1">...</span>}
                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                  .filter((page) => page > 1 && page < totalPages)
                  .map((page) => (
                    <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                  ))}
                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                {totalPages > 1 && (
                  <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light active" : "btn-dark"} border-right`} > {totalPages} </button>
                )}
                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
              </div>
            </div>
          </div>
                </div>
            </div>
        </div>
    );
}
export default CustomerHistory;
